import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=f7c526d4&scoped=true"
import script from "./Documentation.vue?vue&type=script&lang=ts"
export * from "./Documentation.vue?vue&type=script&lang=ts"
import style0 from "./Documentation.vue?vue&type=style&index=0&id=f7c526d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c526d4",
  null
  
)

export default component.exports